module.exports = __webpack_public_path__ + "static/media/ski-lift.d7ca38f8.svg";